"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    // Pages
    ComponentType["AccountPage"] = "account-page";
    ComponentType["GameDetailsPage"] = "game-details-page";
    ComponentType["LatestPage"] = "latest-page";
    ComponentType["LiveEventPage"] = "live-event-page";
    ComponentType["MorePage"] = "more-page";
    ComponentType["Page"] = "page";
    ComponentType["ScoresPage"] = "scores-page";
    ComponentType["TeamPage"] = "team-page";
    ComponentType["VodPage"] = "vod-page";
    ComponentType["WatchPage"] = "watch-page";
    ComponentType["WebPage"] = "web-page";
    ComponentType["WebWatchPage"] = "web-watch-page";
    ComponentType["ContentPage"] = "content-page";
    // Containers
    ComponentType["Grid"] = "grid";
    ComponentType["Group"] = "group";
    ComponentType["Rail"] = "rail";
    ComponentType["ContentItemRail"] = "content-item-rail";
    ComponentType["WatchVideoRail"] = "watch-video-rail";
    ComponentType["TabView"] = "tabview";
    ComponentType["SlidyTabs"] = "slidy-tabs";
    // Cards
    ComponentType["LeagueCard"] = "league-card";
    ComponentType["MatchupCard"] = "matchup-card";
    ComponentType["NewsCard"] = "news-card";
    ComponentType["VideoCard"] = "video-card";
    ComponentType["ScoreCard"] = "score-card";
    ComponentType["ScoreLockup"] = "score-lockup";
    ComponentType["VideoPlaylistCard"] = "video-playlist-card";
    ComponentType["TeamGroupHero"] = "team-group-hero";
    ComponentType["TeamHubPreview"] = "teamhub-preview";
    ComponentType["IconCard"] = "icon-card";
})(ComponentType || (exports.ComponentType = ComponentType = {}));
